import { safeDefine } from "../../registration/safe-define.js";
import { AudioSkinElement } from "../../presets/audio/skin.js";
import "../../internal/skins/default-audio/register.js";
//#region src/define/audio/skin.ts
safeDefine(AudioSkinElement);
//#endregion

//# sourceMappingURL=skin.js.map